import A from 'const/actionTypes'
import actions from 'actions'

export default {
  clearGameSounds: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_GAME_SOUNDS, })
    }
  },
  selectGunSound: (soundChoice) => {
    return (dispatch, getState) => {
      const currentGamerPurchaseProfile = getState().currentGamerPurchaseProfile
      const availableSoundPacks = currentGamerPurchaseProfile.soundPacks || {}

      if (soundChoice.id === 'default' || availableSoundPacks[soundChoice.id]) {
        dispatch({
          type: A.SET_GAME_SOUNDS,
          gameSounds: {
            gunSound: soundChoice.soundId,
          },
        })
      } else {
        dispatch(actions.alertGamer({ message: 'Invalid Selection.', }))
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/gameSounds.js